import { toast } from "react-toastify"
import { _ConfigAdmin } from "../../../../core/services/dataBean/EntityCatalogVdos"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { BasicTable } from "../../../theme/Component/BasicTable"
import { useEffect, useState } from "react";
import { SelectorOffice } from "../../config/Componentes/SelectorOffice";

interface Props {
    idlnArea: number;
    onChange: Function;
}

export const SelectGroupMemberTable = ({ idlnArea, onChange }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_ConfigAdmin)
    const [office, setOffice] = useState<number>(null)

    const head = [
        { title: 'NIT', property: 'AccountID', visible: true },
        { title: 'Usuario', property: 'AccountName', visible: true },
        { title: 'Roles', property: 'BusinessRoleName', visible: true },
    ]

    useEffect(() => {
        if (office) {
            getMemberList()
        }
    }, [office])

    const getMemberList = () => {
        instance.getWorkGroupMemberCatalog(idlnArea, office, 0).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("no se pudieron cargar los miembros del grupo")
            }
        )
    }

    const returnValue = (objeto: any) => {
        setBean(objeto);
        if (onChange) {
            onChange(objeto)
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <SelectorOffice idSelector={office} titulo="Sucursal" onChange={(e: any) => { setOffice(e) }} />
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={returnValue} />
            </div>
        </div>
    )
}